import { AFFILIATE_URL } from "@/lib/api";

export default function SiteFooter() {
  return (
    <footer className="mt-32 border-t border-white/5 px-6 py-12">
      <div className="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl tracking-tight">Naevo <span className="text-magenta">Casino</span></div>
          <p className="mt-3 text-sm text-white/60 max-w-xs">
            A sophisticated trading desk powered by the Deriv API. Automated bots, live markets and a playful arcade — all in one place.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">Product</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="/charts">Charts</a></li>
            <li><a href="/arcade">Arcade</a></li>
            <li><a href="/history">History</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">Resources</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="https://developers.deriv.com/docs/" target="_blank" rel="noreferrer">Deriv API</a></li>
            <li><a href={AFFILIATE_URL} target="_blank" rel="noreferrer">Open Deriv account</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">Legal</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li>CFDs are complex instruments. Trade responsibly.</li>
            <li>© {new Date().getFullYear()} Naevo Casino.</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
